// @flow
import Http from './Http'
import CodeCompletions from './CodeCompletions'

/**
 * SettingTemplate: a type used to define the appearance and behaviour of a setting for Manatee
 * @typedef { Object } SettingTemplate
 * @memberof SettingsSuggestionsService
 */
type SettingTemplate = {
  name: string,
  description: string,
  validation: ?SettingValidation,
  type: string
}

/**
 * SettingValidation determines which validation to perform on the setting.
 * @typedef { Object } SettingTemplate
 * @memberof SettingsSuggestionsService
 */
type SettingValidation = ByRegexValidation | AsUrlValidation

/**
 * ByRegexValidation does regexp based validations.
 * @typedef { Object } ByRegexValidation
 * @memberof SettingsSuggestionsService
 */
type ByRegexValidation = {
  type: string,
  errorMessage: string,
  regexp: string
}

/**
 * AsUrlValidation validates setting is url.
 * @typedef { Object } AsUrlValidation
 * @memberof SettingsSuggestionsService
 */
type AsUrlValidation = {
  type: string,
  errorMessage: string,
  allowEmpty: boolean
}

const forVersion = (version: string): Promise<Array<SettingTemplate>> => {
  return new Promise((resolve, reject) => {
    CodeCompletions.resolveSuggestions(version)
      .then(result => {
        resolve(result.settings.settings)
      })
      .catch(err => reject(err))
  })
}

const getVersions = (type: ?string): Promise<Array<string>> => {
  return CodeCompletions.getVersions(type)
}

const self = {
  forVersion,
  getVersions
}

/**
 * SettingsSuggestions service
 * @module SettingsSuggestionsService
 * @namespace SettingsSuggestionsService
 * @version 1.0.0
 */
export default self
